module.exports = __webpack_public_path__ + "static/media/loading-1.826e16d4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/loading-1.svg
// module id = 86
// module chunks = 7